import React from 'react';
import { Link } from 'react-router-dom';
import './LoginPage.css'; // Reuse the same styling

const TermsPage = () => {
  return (
    <div className="login-page">
      <div className="login-container" style={{ maxWidth: '800px' }}>
        <div className="login-header">
          <img 
            src="/encore_logo_notext_min.png" 
            alt="Panorama" 
            className="login-logo"
          />
          <h1>Terms and Conditions</h1>
        </div>

        <div className="login-content" style={{ textAlign: 'left' }}>
        <div style={{ padding: '20px' }}>
            <p><strong>Last Updated:</strong> 2025-10-20</p>

            <h2>1. Acceptance of Terms</h2>
            <p>
            By accessing or using this invite-only application (“the Service”), you agree to be bound by these Terms of Service 
            (“Terms”) between you (“the user”) and <strong>Encore Interactive Inc.</strong> (“Encore Interactive”, “we”, “us”, or “our”). 
            If you do not agree to these Terms, you may not use the Service.
            </p>

            <h2>2. Description of Service</h2>
            <p>
            The Service is provided by invitation only and allows authorized users to access and interact with Encore Interactive’s 
            digital platform. The Service is provided on a <strong>best-effort basis</strong> and is subject to ongoing development and 
            improvement. We make no guarantees as to availability, accuracy, or completeness of the Service or the data it provides.
            </p>

            <h2>3. User Responsibilities</h2>
            <p>
            You are responsible for maintaining the confidentiality of your account credentials and ensuring that your access to 
            the Service is secure. You agree not to:
            <ul>
                <li>Share your account credentials with others;</li>
                <li>Use the Service for any unlawful or unauthorized purpose;</li>
                <li>Attempt to reverse engineer, disrupt, or interfere with the Service’s functionality or security;</li>
                <li>Provide false or misleading information during registration or use of the Service.</li>
            </ul>
            Encore Interactive reserves the right to suspend or terminate access for any user who violates these Terms.
            </p>

            <h2>4. Privacy</h2>
            <p>
            Your use of the Service is governed by our <a href="/privacy">Privacy Policy</a>, which describes how we collect, use, 
            and protect your personal information in compliance with applicable Canadian privacy laws. By using the Service, you 
            consent to the practices described in that policy.
            </p>

            <h2>5. Intellectual Property</h2>
            <p>
            All content, software, design elements, and related materials provided through the Service are the exclusive property 
            of Encore Interactive Inc. or its licensors and are protected by Canadian and international copyright, trademark, and 
            intellectual property laws.
            </p>
            <p>
            Users are granted a limited, non-transferable, revocable license to access and use the Service for authorized purposes 
            only. No ownership rights are granted, and any unauthorized reproduction, modification, or distribution of materials is prohibited.
            </p>

            <h2>6. Limitation of Liability</h2>
            <p>
            The Service and all data, information, and functionality are provided on an <strong>“as-is”</strong> and 
            <strong>“as-available”</strong> basis, without warranties or conditions of any kind, whether express or implied.
            </p>
            <p>
            <strong>Encore Interactive Inc. provides no guarantees regarding:</strong>
            <ul>
                <li>The accuracy or completeness of any data displayed within the Service;</li>
                <li>The availability, uptime, or performance of the Service;</li>
                <li>The suitability of the Service for any specific purpose.</li>
            </ul>
            </p>
            <p>
            To the fullest extent permitted by law, Encore Interactive Inc. and its directors, officers, employees, and affiliates 
            shall not be liable for any damages, losses, or expenses—direct, indirect, incidental, consequential, or otherwise—arising 
            from or related to:
            <ul>
                <li>Missing, inaccurate, or delayed data;</li>
                <li>Service interruptions, downtime, or technical failures;</li>
                <li>Errors or omissions in the information presented;</li>
                <li>Unauthorized access to or use of user data.</li>
            </ul>
            </p>
            <p>
            Users acknowledge that use of the Service is at their own risk and that Encore Interactive provides the Service without 
            any service-level agreements or performance guarantees.
            </p>

            <h2>7. Modifications and Termination</h2>
            <p>
            Encore Interactive reserves the right to modify, suspend, or discontinue the Service (or any part thereof) at any time 
            without prior notice. We may also update these Terms periodically. Continued use of the Service following any such 
            changes constitutes acceptance of the revised Terms.
            </p>

            <h2>8. Governing Law</h2>
            <p>
            These Terms shall be governed by and interpreted in accordance with the laws of the Province of New Brunswick and the 
            applicable laws of Canada, without regard to conflict of law principles. Any disputes shall be subject to the exclusive 
            jurisdiction of the courts in New Brunswick, Canada.
            </p>

            <h2>9. Contact Information</h2>
            <p>
            For questions, concerns, or requests about this agreement, contact:
            </p>
            <p>
            Encore Interactive Inc.<br />
            Please contact your account manager for contact details<br />
            </p>
        </div>
        </div>


        <div className="login-footer">
          <p>
            <Link to="/login" style={{ color: '#667eea', textDecoration: 'none' }}>
              ← Back to Login
            </Link>
            {' | '}
            <Link to="/privacy" style={{ color: '#667eea', textDecoration: 'none' }}>
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
